import React from "react";
import SoftshelljackePrimoPlus from "../Garments/SoftshelljackePrimoPlus";

export default function SoftshelljackePrimoPlusPage() {
  return <SoftshelljackePrimoPlus />;
}
